var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartOption && _vm.chartOption.series && _vm.chartOption.series.length > 0)?_c('ApexChart',{attrs:{"element":"starboardFlowRateChart","chartOption":_vm.chartOption,"series":_vm.chartOption.series}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }